// extracted by mini-css-extract-plugin
export default {"container":"value-selection-module__container___BOlfy"};